import React from 'react';
import {
  PaymentMethod as PaymentMethodModel,
} from '../../../../structures/models/paymentMethod';
import {
  PaymentMethodRequest,
  SetupIntentPaymentMethodRequest,
} from '../../../../structures/requests/paymentMethod';
import StripeSetupCard from './StripeSetupCard';
import EditExistingPaymentMethod from './EditExistingPaymentMethod';

interface Props {
  setShowForm: React.Dispatch<React.SetStateAction<boolean>>,
  currentPaymentMethod: PaymentMethodModel,
  handleSubmit: (data: SetupIntentPaymentMethodRequest | PaymentMethodRequest) => Promise<void>,
  setErrors: React.Dispatch<React.SetStateAction<string[]>>,
  isProcessing: boolean,
}

const PaymentMethodForm: React.FC<Props> = ({
  setShowForm,
  currentPaymentMethod,
  handleSubmit,
  isProcessing,
  setErrors,
}) => {
  if (currentPaymentMethod.payment_method_id) {
    return (
      <EditExistingPaymentMethod
        currentPaymentMethod={currentPaymentMethod}
        handleSubmit={handleSubmit}
        isProcessing={isProcessing}
        setShowForm={setShowForm}
      />
    );
  }

  return (
    <StripeSetupCard
      setShowForm={setShowForm}
      isProcessing={isProcessing}
      handleSubmit={handleSubmit}
      setErrors={setErrors}
    />
  );
};

export default PaymentMethodForm;
